<template>
	<div id="PageSummary">
		<div class="container content-summary" :class="{'getblurred': isModalVisible}">

			<Title :title="'Complete your reservation'"></Title>

			<div class="row">
				<div class="col wrapper-rounded-content">
					<div class="bg-blue-multiply rounded-corners"></div>

					<CarDetails :group="resCar" :price="resCar.price"></CarDetails>
				</div>
			</div>


			<div class="row">
				<div class="col text-center col-cta-button">
					<button type="button" class="btn btn-primary btn-wp" @click="processReservation">{{ $t('Buy at cost') }}</button>
				</div>
			</div>
		</div>
		<modal v-show="isModalVisible" @clicked="closeModal" :isModalVisible="isModalVisible"	:largeModal="true" :twoButtons="true">
			<h3 slot="headline">{{ $t('Your vehicle is reserved!') }}</h3>
			<p slot="text">{{ $t('Until 1 hour before the start time you have the possibility to change or cancel the booking again.') }}</p>
			<template slot="closeBtn">{{ $t('Start new reservation') }}</template>

			<template slot="firstBtn">{{ $t('To overview') }}</template>
		</modal>
		<div v-show="isModalVisible" @click="closeModal" class="modal-backdrop show"></div>
	</div>
</template>

<script>

import { mapGetters } from 'vuex'
import formatter 		from '@/store/orm/helpers/formater';
export default {
	name: 'PageSummary',
	computed: {
	    ...mapGetters('orm/reservation', {
	    	user_session: 'user_session',
	    	resStation: 'station',
			resStartdate: 'startdate',
			resEnddate: 'enddate',
			resCar: 'car',
			resNavigation: 'navigation',
	    }),
	},

	data(){
		return {
			isModalVisible: false,
			formatter
		};
	},

	mounted(){
		if(!this.resStation){
			this.$router.push({ name: 'PagePlace', params: this.$route.params}); return;
		}

		if(!this.resStartdate){
			this.$router.push({ name: 'PageTime', params: this.$route.params}); return;
		}

		if(!this.resEnddate){
			this.$router.push({ name: 'PageTime', params: this.$route.params}); return;
		}

		if(!this.resCar){
			this.$router.push({ name: 'PageCar', params: this.$route.params}); return;
		}

		if(!this.resCar.price){
			this.$router.push({ name: 'PageCar', params: this.$route.params}); return;
		}
	},
	methods: {
		processReservation(ev){
			var self = this;
			if(!self.user_session) {
				this.$router.push({name: "PageLogin", params: {redirect: 'PageSummary' }});
			} else {
				this.$store.dispatch('orm/reservation/MAKE_RESERVATION')
				.then(result => {
					self.isModalVisible = true;
				})
				.catch(err => { this.$store.commit("core/ADD_ERROR", err); });
			}
		},
		
      	closeModal(value) {
      		switch (value) {
			  case 'close':
			  	this.$router.push({name: "PagePlace", params: {redirect: 'PageSummary' }});
			  	this.isModalVisible = false;
        		document.body.classList.remove("modal-open");
			  	break;
			  case 'submit':
			  	this.$router.push({name: "PageMybookings", params: {redirect: 'PageSummary' }});
			  	break;
			  default:

			}        	
      	},
	}
}






</script>



// WEBPACK FOOTER //
// src/components/Pages/PageSummary.vue